<section>
  <div class="profile-head-div">
    <h1>Profile</h1>
    <!-- <p>profile-page-main-content works!</p> -->
  </div>
  <div class="profile-info-div">
    <ng-template [ngIf]="!url" [ngIfElse]="userUpload">
      <div class="profile-info-picture" *ngIf="!url">
        <img
          [(src)]="env['logo_paths']['profilePageIcon']"
          alt="Photo of user"
        />
      </div>
    </ng-template>

    <ng-template #userUpload>
      <div class="profile-info-picture">
        <img [src]="url" *ngIf="url" />
      </div>
    </ng-template>

    <div class="profile-info-description">
      <div>
        Name: {{ firstName + ' ' + lastName }}
        <mat-divider></mat-divider>
        Role: {{ userRole }}
      </div>
    </div>
  </div>

  <!-- <div class="image-upload-div">
    <div [innerHtml]='msg' *ngIf="msg" class="img-error-msg"></div>
    <div class="upload-img-title">Upload an image for profile picture here: </div>
    <p>
      <input type="file" (change)="selectFile($event)">
    </p>
  </div> -->
</section>
